import { render, staticRenderFns } from "./eventsVideo.vue?vue&type=template&id=01c9b39c&"
import script from "./eventsVideo.vue?vue&type=script&lang=js&"
export * from "./eventsVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/modals/eventsVideo.vue
// module id = 1618
// module chunks = 0